import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import AboutPage from '../AboutPage/AboutPage';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ContactPage from '../ContactPage/ContactPage';
import PrivacePage from '../PrivacePage/PrivacePage';
import TermsPage from '../TermsPage/TermsPage';
import FaqPages from '../faqPages/faqPages';
import ErrorPage from '../ErrorPage/ErrorPage';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutPage />} />
          {/* <Route path="shop" element={<ShopPage />} /> */}
          {/* <Route path='shop-single/:slug' element={<ProductSinglePage />} /> */}
          {/* <Route path='cart' element={<CartPage />} /> */}
          {/* <Route path='checkout' element={<CheckoutPage />} /> */}
          {/* <Route path='order_received' element={<OrderRecived />} /> */}
          <Route path="service" element={<ServicePages />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          {/* <Route path="pricing" element={<PricingPage />} /> */}
          {/* <Route path='blog' element={<BlogPage />} /> */}
          {/* <Route path='blog-single/:slug' element={<BlogDetails />} /> */}
          <Route path='contact' element={<ContactPage />} />
          <Route path="privace" element={<PrivacePage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="faq" element={<FaqPages />} />
          <Route path='404' element={<ErrorPage />} /> 
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
